import { render, staticRenderFns } from "./ReviewProfile.vue?vue&type=template&id=68458575"
import script from "./ReviewProfile.vue?vue&type=script&lang=js"
export * from "./ReviewProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports